<template>
  <div 
    class="base-element-svg"
    :style="{
      top: elementInfo.top + 'px',
      left: elementInfo.left + 'px',
      width: elementInfo.width + 'px',
      height: elementInfo.height + 'px',
    }"
  >
    <div
      class="rotate-wrapper"
      :style="{ transform: `rotate(${elementInfo.rotate}deg)` }"
    >
      <div 
        class="element-content"
        :style="{
          transform: flipStyle
          }"
      >
        <svgElement 
        
        :style="{
          opacity: elementInfo.opacity,
          filter: shadowStyle ? `drop-shadow(${shadowStyle})` : '',
          }"
          overflow="visible" 
          :width="elementInfo.width"
          :height="elementInfo.height"
        >
                   <g 
           
           v-html="elementInfo.svg"
            :transform="`scale(${elementInfo.width / (elementInfo.viewBoxW && elementInfo.viewBoxW>0?elementInfo.viewBoxW:elementInfo.viewBox)}, ${elementInfo.height / (elementInfo.viewBoxH && elementInfo.viewBoxH>0 ? elementInfo.viewBoxH: elementInfo.viewBox)}) translate(0,0) matrix(1,0,0,1,0,0)`"
          ></g>
        </svgElement>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, toRef } from 'vue'
import { PPTSvgElement } from '@/types/slides'
import useElementOutline from '@/views/components/element/hooks/useElementOutline'
import useElementShadow from '@/views/components/element/hooks/useElementShadow'
import useElementFlip from '@/views/components/element/hooks/useElementFlip'
import tinycolor from 'tinycolor2'
export default defineComponent({
  name: 'base-element-svg',
  props: {
    elementInfo: {
      type: Object as PropType<PPTSvgElement>,
      required: true,
    },
  },
  setup(props) {
    const outline = computed(() => props.elementInfo.outline)
    const { outlineWidth, outlineStyle, outlineColor } = useElementOutline(outline)
    
    const shadow = computed(() => props.elementInfo.shadow)
    const { shadowStyle } = useElementShadow(shadow)

    const flipH = computed(() => props.elementInfo.flipH)
    const flipV = computed(() => props.elementInfo.flipV)
    const { flipStyle } = useElementFlip(flipH, flipV)
    const elementInfo = toRef(props, 'elementInfo')
    let path = elementInfo.value.path
    elementInfo.value.colors.forEach((item, ind) => {
      const items = tinycolor(item) as never
      path = path.replaceAll('color[' + ind + ']', items)
    })
    elementInfo.value.svg = path
    return {
      shadowStyle,
      outlineWidth,
      outlineStyle,
      outlineColor,
      flipStyle
    }
  },
})
</script>

<style lang="scss" scoped>
.base-element-svg {
  position: absolute;
}
.rotate-wrapper {
  width: 100%;
  height: 100%;
}
.element-content {
  width: 100%;
  height: 100%;
  position: relative;

  svg {
    transform-origin: 0 0;
    overflow: visible;
    position: absolute;
  }
}
.shape-text {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 10px;
  line-height: 1.2;
  word-break: break-word;

  &.top {
    justify-content: flex-start;
  }
  &.middle {
    justify-content: center;
  }
  &.bottom {
    justify-content: flex-end;
  }
}
</style>
